var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.icon_number)?_c('img',{staticClass:"cc-icon",attrs:{"src":_vm.icon_url}}):_c('i',{staticClass:"fad fa-credit-card"})])}
var staticRenderFns = []

export { render, staticRenderFns }